module.exports = __webpack_public_path__ + "img/58.7fc710e2.jpg";